import { CreateReservationDTO, ReservationDTO } from '../types/reservation';
import { Resource } from '../types/resource';
import { ResourceType } from '../types/resourceType';
import { VisitorType } from '../types/visitor';
import api from './axios';

const baseUrl = '/rest/v1/reservations'

export async function getReservations(params: { from: string, to: string, reservationType?: 'INTERNAL' | 'EXTERNAL', resourceTypes?: ResourceType[], resources?: Resource[], visitorTypes?: VisitorType[], own?: boolean }): Promise<PagedResult<ReservationDTO>> {
  const query = { params: {} as Record<string, string | string[]> }

  query.params['from'] = params.from
  query.params['to'] = params.to

  if (params.reservationType) {
    query.params['reservationType'] = params.reservationType
  }

  if (params.resourceTypes) {
    query.params['resourceTypeId'] = params.resourceTypes.map(rt => rt.id)
  }

  if (params.resources) {
    query.params['resourceId'] = params.resources.map(r => r.id)
  }

  if (params.visitorTypes) {
    query.params['visitorType'] = params.visitorTypes.map(vt => vt.toString())
  }

  if (params.own) {
    query.params['own'] = 'true'
  }

  const res = await api.get(baseUrl, query)
  return res.data
}

export async function validateReservation(data: CreateReservationDTO, id?: string): Promise<ErrorMessage | void> {
  try {
    await api.post(`${baseUrl}/validate`, data, { params: id ? { id } : undefined })
  } catch (error: any) {
    if (error?.response?.status === 400) {
      return {
        errorCode: error.response.data.errorCode,
        message: error.response.data.message
      }
    }

    throw error
  }
}

export async function createReservation(data: CreateReservationDTO): Promise<ErrorMessage | ReservationDTO> {
  try {
    const res = await api.post(baseUrl, data)
    return res.data
  } catch (error: any) {
    if (error?.response?.status === 400) {
      return {
        errorCode: error.response.data.errorCode,
        message: error.response.data.message
      }
    }
    throw error
  }
}

export async function updateReservation(id: string, data: CreateReservationDTO): Promise<ErrorMessage | ReservationDTO> {
  try {
    const res = await api.put(`${baseUrl}/${id}`, data)
    return res.data
  } catch (error: any) {
    if (error?.response?.status === 400) {
      return {
        errorCode: error.response.data.errorCode,
        message: error.response.data.message
      }
    }
    throw error
  }
}

export async function confirmReservation(id: string): Promise<ErrorMessage | ReservationDTO> {
  const res = await api.get(`${baseUrl}/${id}/confirm`)
  return res.data
}

export async function deleteReservation(id: string): Promise<ErrorMessage | void> {
  await api.delete(`${baseUrl}/${id}`)
}

export async function cancelReservation(id: string, reason?: string): Promise<ErrorMessage | void> {
  await api.post(`${baseUrl}/${id}/cancel`, { data: { reason } })
}

export async function fetchResourceOccupiedCapacity(resourceId: string, fromMs: number, toMs: number, excludeReservationId: string | null): Promise<{ total: number, available: number }> {
  const res = await api.get(`${baseUrl}/capacity`, {
    params: {
      resourceId: resourceId,
      from: fromMs,
      to: toMs,
      excludeReservationId: excludeReservationId ?? undefined
    }
  })
  return res.data
}